export default __webpack_public_path__ + "static/media/maths.23127134.png";